<div class="version-label">
    @if (!showPassiveCountdown) {
    <span class="version-label__text"
        [class.version-label__text--update-available]="isReloadCandidate() && !shouldReloadNow()"
        [class.version-label__text--reload-required]="shouldReloadNow()">
        v{{ currentVersion }}
    </span>
    }

    @if (isReloadCandidate() && mode() === 'interactive') {
    <div class="version-label__update">
        <span class="version-label__available-text">
            Update available
        </span>
        <div class="version-label__action-row">
            <button type="button" class="btn-link btn-link-primary version-label__update-btn m-0 p-0 text-nowrap"
                (click)="updateNow()">
                Update now
                @if (shouldReloadNow()) {
                <span class="version-label__countdown">
                    ({{ countdownSeconds }}s)
                </span>
                }
            </button>
        </div>
    </div>
    }

    @if (showPassiveCountdown) {
    <span class="version-label__passive-countdown">
        Reloading in {{ countdownSeconds }}s
    </span>
    }
</div>
